import { refreshCSRFToken } from "./csrf.js";

let lastActiveTime = Date.now();
const CSRF_LIFETIME = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

document.addEventListener("visibilitychange", async () => {
    if (!document.hidden) {
        const timeInactive = Date.now() - lastActiveTime;

        // If page was inactive for more than 1.5 hours, refresh token
        if (timeInactive > CSRF_LIFETIME * 0.75) {
            try {
                await refreshCSRFToken();
            } catch (error) {
                console.error("Failed to refresh CSRF token:", error);
            }
        }
    } else {
        lastActiveTime = Date.now();
    }
});
